module.exports = __webpack_public_path__ + "static/assets/82e2890b48df96037aeb0e965cdd1cee.gif";